import ConfirmationModal from 'legacy/app/components/modal/ConfirmationModal';
import URI from 'legacy/defaults/RoutesDefault';

export const LoggedOutModal = ({
	show,
	confirmAction,
}: {
	show: boolean;
	confirmAction: () => void;
}) => (
	<ConfirmationModal
		title=""
		okButtonClassName="!tw-w-20 !tw-m-auto"
		confirmAction={confirmAction}
		okBtnStyle="primary"
		hideCancel
		show={show}
	>
		<div className="tw-grid tw-grid-flow-row tw-gap-3 tw-p-4">
			<p className="tw-text-base tw-font-extrabold tw-text-center tw-m-0">
				Another device is signing in with this account.
			</p>
			<div className="tw-text-base">
				<p className="tw-text-center tw-m-0">
					Sharing logins may sign out others. To keep things running smoothly,
					please{' '}
					<a
						target="_blank"
						href={`${window.location.protocol}//${window.location.host}${URI.settings.userManagement.add}`}
						rel="noreferrer"
						className="tw-text-[#212529]"
					>
						click here
					</a>{' '}
					to add
					<br /> another user license.
				</p>
				<p className="tw-text-center tw-m-0">
					We&apos;re here if you need help!
				</p>
			</div>
		</div>
	</ConfirmationModal>
);
LoggedOutModal.displayName = 'LoggedOutModal';
